<template>
  <div class="page-main">
    <Banner bannerImage="bannerAgence"/>
    <TabMenu>
      <template v-slot:body>
        <!-- Plus tard, la page agence par défaut sera de l'analyse, et il y aura un second onglet pour contrôle de saisies avec une route différente. -->
        <Tab text="Contrôle des saisies"  route="/agence"  customWidth=180 />
      </template>
    </TabMenu>
    <div  class="page-main-container">
      <div class="option">
        <select-coeff/>
        <AgenceFilter v-if="operationList" @fullyLoaded="loadingState($event)" @analyseRH="getAnalyseRH($event)"
                      @analyseCA="getAnalyseCA($event)"  @analyseNotes="getAnalyseNotes($event)" @avgNonFacturable="getAgenceAvgNonFacturable($event)"
                      :year="year" ref="agenceFilterInterface"/>
      </div>
      <div v-if="!fullyLoaded" class="spinner"><Spinner/></div>
      <div v-else class="dashboard">
        <div class="year">
          <span class="material-icons year-arrow" @click="yearDown()">chevron_left</span>
          <input type="Number" step="1" v-model="year" class="year-input">
          <span class="material-icons year-arrow" @click="yearUp()">chevron_right</span>
        </div>
        <div class="resultats">
          <Section text="Temps passés" class="section" underlined="true">
            <template v-slot:body>

              <div>
                <div class="resultats-line resultats-header time">
                  <div>Total :</div>
                  <div>{{ttJours.toFixed(1)}} jours</div>
                </div>
                <div v-for="(item, index) in jours" :key="index" class="resultats-line time">
                  <div>{{item.name}} {{item.surname}}</div>
                  <div>{{item.value.toFixed(1)}} jours</div>
                </div>
                <br/>
                <div>Temps facturable moyen {{ updateMontant(avgNonFacturable).str }}%</div>
              </div>
            </template>
          </Section>
          <Section text="Achats (prestations + frais)" class="section" underlined="true">
            <template v-slot:body>
                <div class="resultats-line resultats-header achats">
                  <div>Total :</div>
                  <div>{{updateMontant(ttAchat).str}} €</div>
                </div>
                <div v-for="(item, index) in analyseNotes" :key="index" class="resultats-line achats">
                  <div>{{item.labelName}} {{item.surname}}</div>
                  <div>{{updateMontant(item.total.toFixed(0)).str}} €</div>
                </div>
              <!-- <div class="achat">
                <table>
                  <tr><th><td>Total: {{ttAchat + '€' }}</td></th></tr>
                  <tr><th>Prestation Externes</th></tr>

                  <tr v-for="(item, index) in analyseNotes.prestas" :key="'ndp' + index">
                    <td>{{item.labelName}} :</td>
                    <td>{{item.total + ' €'}}</td>
                  </tr>
                  <tr><th><td>Notes de frais</td></th></tr>
                  <tr v-for="(item, index) in analyseNotes.frais" :key="'ndf' + index">
                    <td>{{item.labelName}} : </td>
                    <td>{{item.total + ' €'}}</td>
                  </tr>
                </table>
              </div> -->
            </template>
          </Section>
          <Section text="Ventes (Factures)" class="section" underlined="true">
            <template v-slot:body>
              <div class="resultats-line resultats-header ventes">
                <div>Total :</div>
                <div>{{updateMontant(totalCA).str}} €</div>
              </div>
              <div v-for="(item, index) in analyseCA" :key="index" class="resultats-line ventes">
                <div>{{item.nomProjet}}</div>
                <div>{{updateMontant(item.montants).str}} €</div>
              </div>
            </template>
          </Section>
          <Section text="Rémunération annuelle" class="section" underlined="true">
            <template v-slot:body>
                <div class="resultats-line resultats-header remuneration">
                  <div>Prénom</div>
                  <div>Nom</div>
                  <div>Montant</div>
                </div>
                <div v-for="(item, index) in remuneration" :key="index" class="resultats-line remuneration">
                  <div>{{item.name}}</div>
                  <div>{{item.surname}}</div>
                  <div>{{updateMontant(item.value).str}} €</div>
                </div>
            </template>
          </Section>
          <Section text="Salaire Brut Journalier" class="section" underlined="true">
            <template v-slot:body>
              <div class="resultats-line resultats-header salaire">
                <div>Prénom</div>
                <div>Nom</div>
                <div>SBJ</div>
                <div>x Coeff</div>
              </div>
                <div v-if= "analyseRH.coeff.length === 0">
                  <div>Il n'y a pas de coefficient pour cette année</div>
                </div>
                <div v-else>
                  <div v-for="(item, index) in salBrutJournalier" :key="index" class="resultats-line salaire">
                    <div>{{item.name}}</div>
                    <div>{{item.surname}}</div>
                    <div>{{item.sbj}}</div>
                    <div>{{item.xCoef}}</div>
                  </div>
              </div>
            </template>
          </Section>
        </div>
      </div>
    </div>
  <Footer/>
  </div>
</template>

<script>
import Banner from '../components/PageBanner';
import TabMenu from '../components/PageTabMenu';
import Tab from '../components/PageTab';
import Spinner from '../components/Spinner';
import Section from '../components/PageSection';
import Footer from '../components/Footer';
import {updateMontant} from '@/mixins/updateMontant';
import SelectCoeff from "@/components/SelectCoeff";
import AgenceFilter from  "../components/AgenceFilter";
export default {
  name: 'PageAgence',
  components:{
    AgenceFilter,
    SelectCoeff,
    Banner,
    TabMenu,
    Tab,
    Spinner,
    Section,
    Footer,
  },
  mixins:[updateMontant],
  data(){
    return {
        analyseRH: {},
        analyseCA: {},
        collaborator: {},
        analyseNotes: {},
        fullyLoaded: false,
        year: 0,
        operationList: {},
        opsInfo: {},
        modeSaisie: null,
        total: 0,
        avgNonFacturable:0,
        coeff:{
          id: "",
          agenceId: "",
          annee: 0,
          labelId: "",
          val: 0
        }
    }
  },
  beforeMount() {
    let myYear = new Date()
    this.year = myYear.getFullYear()
  },
  mounted(){
    this.$axios.get('agences/mode/' + this.$store.state.auth.currentAgence._id)
    .then(res => {
        this.modeSaisie = res.data;
    })
  },
  computed:{
    // ---------
    //    RH
    // ---------
        ttAchat(){
          // let a = this.updateMontant(this.totalPrestas).num
          // let b = this.updateMontant(this.totalFrais).num
          // return (a+b).toFixed(0)

          let myTotal = 0
            for (const item of this.analyseNotes) {
                myTotal += item.total
            }
          return myTotal.toFixed(0)
        },

        ttJours(){
          let total = 0
          for (let user of this.analyseRH.rh){
              total += user.jours
          }
          return total
        },
        jours(){
            let myArray = []
            for (let user of this.analyseRH.rh){
                let item = {
                    name: user.name,
                    surname: user.surname,
                    value: user.jours
                }
                myArray.push(item)
            }
            return myArray
        },
        heures(){
          let myArray = []
            for (let user of this.analyseRH.rh){
                let item = {
                    name: user.name,
                    surname: user.surname,
                    value: user.heures
                }
                myArray.push(item)
            }
            return myArray
        },
        remuneration(){
          let myArray = []

          for (let user of this.analyseRH.rh){
              let item = {
                  name: user.name,
                  surname: user.surname,
                  value: user.remunerationCalculee
              }
              myArray.push(item)
          }
          return myArray
        },
        salBrutJournalier(){
          let array = []
          try{
            for (let user of this.analyseRH.rh){
            let item = {}
            //console.log(user)
            if(this.analyseRH.coeff.length === 0){
              console.log("no coef availlable for the current selected year")
            }else{
              for (let coeff of this.analyseRH.coeff)
              {
                if(coeff.labelId === this.$store.state.auth.currentCoeff)
                {
                  let xCoefTronc =user.sbj * coeff.val
                  xCoefTronc = xCoefTronc.toFixed(0)
                  item = {
                    name: user.name,
                    surname: user.surname,
                    sbj: user.sbj.toFixed(0) + ' €',
                    xCoef: xCoefTronc +' €'
                  }
                }
              }
            }
            array.push(item)
          }
          }catch(err){
            err.stack
          }
          return array
        },
    // ---------
    //    CA
    // ---------
        totalCA(){
            let myTotal = 0
            try{
              for (const projet of this.analyseCA) {
                myTotal += projet.montants
            }
            }catch(err){
              err.stack
            }
            return myTotal
        },
    // ---------
    //   Notes
    // ---------
        totalFrais(){
            let myTotal = 0
            try{
              for (const item of this.analyseNotes.frais) {
                myTotal += item.total
            }
            }catch(err){
              err.stack
            }
            return myTotal
        },
        totalPrestas(){
            let myTotal = 0
            for (const item of this.analyseNotes.prestas) {
                myTotal += item.total
            }

            return myTotal
        },
  },
  methods:{
    loadingState(state){
      this.fullyLoaded = state
    },
    yearUp(){
      this.fullyLoaded = false
      this.year = this.year + 1
      this.$refs.agenceFilterInterface.year =  this.$refs.agenceFilterInterface.year + 1
      this.$refs.agenceFilterInterface.processPayload()
    },
    yearDown(){
      this.fullyLoaded = false
      this.year = this.year - 1
      this.$refs.agenceFilterInterface.year =  this.$refs.agenceFilterInterface.year - 1
      this.$refs.agenceFilterInterface.processPayload()
    },

    getAnalyseRH(data){
      this.analyseRH = data
    },
    getAnalyseCA(data){
      this.analyseCA = data
      // console.log(this.analyseCA)
    },
    getAnalyseNotes(data){
      this.analyseNotes = data
      // console.log(this.analyseNotes)
    },
    getAgenceAvgNonFacturable(data){
      this.avgNonFacturable = data
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/main.scss';

@include page-main;

.section{
    margin: 10px 0 0 0;
}
.page-main-container{
  display: flex;
}
.spinner{
  flex:1;
}
.option{
  display: flex;
  flex-direction: column;
  margin: 0 6% 0 0;
}

.year-input{
  background-color: white !important;
}

.dashboard{
  display: flex;
  flex-direction: column;

  @include myBlock;
  padding: 2%;

  @include myFont;
  color: $black-bolder;
  font-size: 13px;
  vertical-align: text-top;


  .year{
    display: flex;
    align-items: center;
    justify-content: center;

    &-input{
      font-size: 28px;
      border: none;
      background-color: $black-lighter;
      color: $main;
      text-align: center;
      width: 80px;

      // Supprimer les flèches du type Number
      -moz-appearance: textfield;
      &::-webkit-inner-spin-button{
        -webkit-appearance: none;
        margin: 0;
      }
    }

    &-arrow{
      font-size: 36px;
      color: $main;
    }
  }
  .resultats{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 50px;

    &-header{
      font-weight: 700;
      font-size: 13px !important;
      margin: 0 0 2px 0;
    }

    &-line{
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      @include monoline;

      & *{
        @include monoline;
      }

      & :nth-last-child(1){
        text-align: right;
      }
    }
    .time{
      table{
        width: 100%;
        border-collapse: separate;
        border-spacing: 10px 0 ;
        tbody{
          tr{
            td{

            }
          }
        }
      }
    }
    .salaire{
      & *{
        flex: 1;
      }

      & :nth-child(3){
        text-align: right;
      }
    }
    .achats{
      table{
        width: 100%;
        border-collapse: separate;
        border-spacing: 10px 0 ;
        tbody{
          tr{
            td{

            }
          }
        }
      }
    }
    .ventes{
      table{
        width: 100%;
        border-collapse: separate;
        border-spacing: 10px 0 ;
        tbody{
          tr{
            td{

            }
          }
        }
      }
    }
    .remuneration{
      & *{
        flex: 1;
      }
    }
  }
}
</style>
